module.exports = __webpack_public_path__ + "static/media/view fees type.572e0905.svg";